import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

function Dashboard({color, classes = '', url}) {
    const navigate = useNavigate();
    const onMenuClick = () => {
        navigate(`/${url}`);
    }
    return (
        <div className={classes} onClick={onMenuClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19.309" viewBox="0 0 18 19.309">
                <g id="coffee-svgrepo-com" transform="translate(-2)">
                    <path id="Path_11565" data-name="Path 11565"
                          d="M34.1,20.491a.327.327,0,1,0-.294.585,3.449,3.449,0,0,1,.894.646.327.327,0,1,0,.463-.463A4.082,4.082,0,0,0,34.1,20.491Z"
                          transform="translate(-21.275 -13.762)" fill={color}/>
                    <path id="Path_11566" data-name="Path 11566"
                          d="M23.727,19.258a4.089,4.089,0,0,0-3.347,1.179.327.327,0,1,0,.463.463,3.447,3.447,0,0,1,2.814-.991.327.327,0,0,0,.07-.651Z"
                          transform="translate(-12.3 -12.939)" fill={color}/>
                    <path id="Path_11567" data-name="Path 11567"
                          d="M20,10.309a9.013,9.013,0,0,0-2.552-6.274,2.185,2.185,0,0,0,1.632-1.907C19.079.954,17.772,0,16.165,0a3.606,3.606,0,0,0-1.93.529,4.515,4.515,0,0,1-2.452.78H5.068a.778.778,0,0,0-.777.777v.082a.778.778,0,0,0,.777.777h.761a9,9,0,0,0,10.234,14.8,1.219,1.219,0,0,0,1.615-.1,1.227,1.227,0,0,0,.177-1.5A8.978,8.978,0,0,0,20,10.309Zm-17.345,0A8.325,8.325,0,0,1,7.074,2.945h4.709a3.983,3.983,0,0,1,.925.11,4.955,4.955,0,0,1,1.527.67l0,0a3.078,3.078,0,0,0,.39.208l.054.025a3.684,3.684,0,0,0,1.446.292l.035,0c.035,0,.069,0,.1,0s.086,0,.13,0q.15-.009.3-.028H16.7a8.344,8.344,0,0,1,.713,11.429c-.269-.267-.688-.682-.982-.972l-.009-.009-.114-.112a6.7,6.7,0,1,0-1.8,1.617l.1.1.047.049.069.072.044.046.085.088.043.044c.231.238.49.5.693.71A8.344,8.344,0,0,1,2.655,10.309ZM10.983,15.8A5.4,5.4,0,1,1,14.8,14.22,5.365,5.365,0,0,1,10.983,15.8Z"
                          fill={color}/>
                </g>
            </svg>
        </div>
    );
}

export default Dashboard;
